// @ts-nocheck

import v4 from 'uuid/v4';

import networkActions from '../../../../actions/network';
import { BetslipOptionsActionTypes } from '../../types/actions/betslipOptions';

export const handledActionTypes = [
  BetslipOptionsActionTypes.ADD_BET_TO_FAVORITES,
  BetslipOptionsActionTypes.REMOVE_BET_FROM_FAVORITES,
  BetslipOptionsActionTypes.HIDE_BET,
  BetslipOptionsActionTypes.REMOVE_HIDE_BET,
];

const BetslipOptionsMiddlewareHandler = ({ store: { dispatch }, action }: HandlerProps) => {
  const { type: actionType } = action;

  if (handledActionTypes.indexOf(actionType) !== -1) {
    if (action.type === BetslipOptionsActionTypes.ADD_BET_TO_FAVORITES) {
      const { betslipId } = action.payload;

      const uniqId = v4();
      dispatch(
        networkActions.send({
          betslipFilters: {
            method: 'addFavorite',
            id: uniqId,
            params: {
              betslipId,
            },
          },
        }),
      );
    }

    if (action.type === BetslipOptionsActionTypes.REMOVE_BET_FROM_FAVORITES) {
      const { betslipId } = action.payload;

      const uniqId = v4();
      dispatch(
        networkActions.send({
          betslipFilters: {
            method: 'removeFavorite',
            id: uniqId,
            params: {
              betslipId,
            },
          },
        }),
      );
    }

    if (action.type === BetslipOptionsActionTypes.HIDE_BET) {
      const { betslipId } = action.payload;

      const uniqId = v4();
      dispatch(
        networkActions.send({
          betslipFilters: {
            method: 'addHidden',
            id: uniqId,
            params: {
              betslipId,
            },
          },
        }),
      );
    }

    if (action.type === BetslipOptionsActionTypes.REMOVE_HIDE_BET) {
      const { betslipId } = action.payload;

      const uniqId = v4();
      dispatch(
        networkActions.send({
          betslipFilters: {
            method: 'removeHidden',
            id: uniqId,
            params: {
              betslipId,
            },
          },
        }),
      );
    }
  }
};

export default BetslipOptionsMiddlewareHandler;
